import { TranslatableKey } from '@app/types/translatable.type';

const GoalMetricsDisplayOptions: { [key: string]: TranslatableKey } = {
    dollar: 'performance.goal-summary.metricLabels.dollar',
    percent: 'performance.goal-summary.metricLabels.percent',
    number: 'performance.goal-summary.metricLabels.number',
    binary: 'performance.goal-summary.metricLabels.binary',
    milestones: 'performance.goal-summary.metricLabels.milestones',
};

export { GoalMetricsDisplayOptions };
